import { useContext } from 'react'
import { NavigationContext } from './NavigationContext'
import { HistoryContext } from './NavigationProvider'
export function useHistory() {
  return useContext(HistoryContext)
}
export default function useRouter() {
  return useContext(NavigationContext)
}
